import React from 'react'
import PropTypes from 'prop-types'
import {SimpleGrid} from '@salesforce/retail-react-app/app/components/shared/ui'
import ProductTile, {Skeleton as ProductTileSkeleton} from '../../../components/product-tile'
import {PRODUCT_LIST_IMAGE_VIEW_TYPE} from '@salesforce/retail-react-app/app/constants'

const ProductSetGrid = ({products = [], isLoading, showQV = false, showSwatches = false, onProductClick}) => {
    return (
        <SimpleGrid
            columns={2}
            spacingX={2}
            spacingY={{base: 4, md: 7}}
            data-testid="product-set-grid"
        >
            {isLoading
                ? Array.from({length: 4}).map((_, index) => <ProductTileSkeleton key={index} />)
                : products.map((childProduct, index) => {
                      const key = childProduct.id || childProduct.productId
                      return (
                          <ProductTile
                              key={key}
                              product={childProduct}
                              onClick={onProductClick ? (selection) => onProductClick({...selection, index}) : undefined}
                              showSwatches={showSwatches}
                              showVideo
                              showDetails
                              enableFavourite={false}
                              showQV={showQV}
                              imageViewType={PRODUCT_LIST_IMAGE_VIEW_TYPE}
                              dynamicImageProps={{
                                  widths: ['50vw', '50vw', '25vw', '25vw'],
                                  imageProps: {
                                      loading: 'lazy'
                                  }
                              }}
                          />
                      )
                  })}
        </SimpleGrid>
    )
}

ProductSetGrid.propTypes = {
    products: PropTypes.array,
    isLoading: PropTypes.bool,
    showQV: PropTypes.bool,
    showSwatches: PropTypes.bool,
    onProductClick: PropTypes.func
}

export default ProductSetGrid
